import { useQuery } from '@tanstack/react-query';

import { commentCodesService } from 'services';
import { isListEnabled } from 'utils/queryHelpers';
import { QueryContextFromKeys, QueryParamModel } from 'models';

type CommentCodesContexts = QueryContextFromKeys<typeof commentCodesKeys>;

export const commentCodesKeys = {
  all: [{ scope: 'commentCodes' }] as const,
  lists: () => [{ ...commentCodesKeys.all[0], entity: 'list' }] as const,
  list: (params?: QueryParamModel | null) => [{ ...commentCodesKeys.lists()[0], params }] as const,
};

const fetchList = async ({ queryKey: [{ params }] }: CommentCodesContexts['list']) =>
  commentCodesService.getCommentCodes(params);

export const useCommentCodesList = (params?: QueryParamModel | null) => {
  return useQuery({
    queryKey: commentCodesKeys.list(params),
    queryFn: fetchList,
    enabled: isListEnabled(params),
  });
};
